import { defineTokens } from '@pandacss/dev'

export const radii = defineTokens.radii({
  none: { value: '0' },
  '2xs': { value: '0.0625rem' },
})
